/** @file 抽奖 语言配置 */
const zhCN = {
  lottery: {
    SFCongratulationsWinner: '恭喜你中奖啦！祝你福星高照、好运常在， 虎年事事顺心，幸福美满！',
    netError: '网络已断开，请刷新重试',
    congratulationsWinner: '恭喜你抽中',
    redeemCode: '兑换码为',
    SFParticipation: '虽然这次没有中奖，但好运一定会伴随着最可爱的你！',
    participation: '很遗憾您未中奖，谢谢参与',
    checkList: '查看中奖名单',
    deadlineOver: '中奖信息填写已截止',
    gotIt: '知道了',
    ok: '我知道了',
    fillInformation: '为了顺利送达奖品，我们需要您提供个人信息，请务必填写正确。',
    deadlineFillInformation: '为了顺利送达奖品，我们需要您提供个人信息，请务必填写正确。截止填写时间： <span style="color: #FF5722">{date}</span>',
    deadlineTip: '您已超过填写联系信息的有效期',
    receivedInformation: '已提交信息成功! 后续会有工作人员与您联系',
    submit: '提交',
    name: '姓名',
    realName: '请输入您的真实姓名',
    requiredText: '(必填)',
    phone: '手机',
    enterPhone: '请输入您的手机号码',
    wrongName: '请输入您的姓名',
    wrongPhone: '号码错误',
    winnerList: '中奖名单',
    back: '返回',
    submitInfomation: '填写联系信息',
    know: '我知道了',
    inLottery: '开奖中',
    lotteryEnd: '已开奖',
    receive: '领取',
    hasReceived: '已领取',
    lotteryPendantTip1: '抽奖暂未开始',
    lotteryPendantTip2: '抽奖即将开始',
    groupEmpty: '该分组没有中奖用户~'
  },
};

const en = {
  lottery: {
    SFCongratulationsWinner: '恭喜你中奖啦！祝你福星高照、好运常在， 虎年事事顺心，幸福美满！',
    netError: 'Network Error',
    congratulationsWinner: 'Congratulations on winning the ',
    redeemCode: 'Your redeem code is',
    SFParticipation: '虽然这次没有中奖，但好运一定会伴随着最可爱的你！',
    participation: 'Sorry, you didn\'t win.',
    checkList: 'Check out the list',
    deadlineOver: 'Over Time',
    gotIt: 'OK',
    ok: 'OK',
    fillInformation: 'To ensure the prize reaches you, we require your personal information, please fill it in accurately.',
    deadlineFillInformation: 'To ensure the prize reaches you, we require your personal information, please fill it in accurately. Deadline: <span style="color: #FF5722">{date}</span>.',
    deadlineTip: 'You have exceeded the expiry date for filling in your contact information',
    receivedInformation: 'submit information successfully!  A staff will contact you later',
    submit: 'Submit',
    name: 'name',
    realName: 'Please enter your real name',
    requiredText: '(Required)',
    phone: 'phone',
    enterPhone: 'Please enter your mobile phone number',
    wrongName: 'Please enter your name',
    wrongPhone: 'Wrong mobile phone number',
    winnerList: 'list',
    back: 'Back',
    submitInfomation: 'Fill in the information',
    know: 'OK',
    inLottery: 'in lottery',
    lotteryEnd: 'Over',
    receive: 'To get',
    hasReceived: 'Got',
    lotteryPendantTip1: 'Not to start',
    lotteryPendantTip2: 'About to start',
    groupEmpty: 'There are no winning users in this group'
  },
};

export default {
  zh_CN: zhCN,
  en,
};
